export const displaysOptionData = [{
  label: '单行文本',
  value: 'SINGLE_ROW'
}, {
  label: '多行文本',
  value: 'MULTILINE'
}, {
  label: '单选',
  value: 'RADIO'
}, {
  label: '复选',
  value: 'CHECK'
}, {
  label: '下拉选项列表',
  value: 'SELECT'
}, {
  label: '时间插件',
  value: 'TIME'
}, {
  label: '图片',
  value: 'IMG'
}];
import request from '@/utils/request';
/**获取列表数据 */
export function getLibraryList(data) {
  return request.post('admin/field-library/list', data);
}

/**新增字段 */
export function newStoreLibrary(data) {
  return request.post('admin/field-library/store', data);
}
//添加字典项
export function addDirectionaryItem(data) {
  return request.post('/admin/field-library/expand/edit', data);
}
//删除字段
export function deleteLibrary(data) {
  return request.post('/admin/field-library/delete', data);
}

//获取字段详情
export function getLibraryDetail(data) {
  return request.post('/admin/field-library/detail', data);
}

//编辑字段
export function editLibrary(data) {
  return request.post('/admin/field-library/edit', data);
}